export const organizationPrivateOptions = [
  {
    label: "Privado",
    value: "private"
  },
  {
    label: "Público",
    value: "public"
  }
];